import instantsearch from "instantsearch.js";
import algoliasearch from "algoliasearch";
import helper from "algoliasearch-helper";

let algoliaClient;
let algoliaHelper;
let searchIndex;
let refine;
let indexName;

function algolia(algoliaIndex) {
  if (!indexName) {
    indexName = algoliaIndex ? algoliaIndex : 'instant_search';
  }

  if (!algoliaClient && !algoliaIndex) {
    algoliaClient = algoliasearch(
      "latency",
      "6be0576ff61c053d5f9a3225e2a90f76"
    );
  } else {
    algoliaClient = algoliasearch(
      "9DI1L1RCYV",
      "f81a9b9f3b00fa487c80297670fbe81b"
    );
  }

  const searchClient = {
    search(requests) {
      if (requests.every(({ params }) => !params.query)) {
        return Promise.resolve({
          results: requests.map(() => ({
            hits: [],
            nbHits: 0,
            nbPages: 0,
            processingTimeMS: 0,
          })),
        });
      }
  
      return algoliaClient.search(requests);
    },
  };

  algoliaHelper = helper(algoliaClient, indexName);

  if (!searchIndex) {
    searchIndex = instantsearch({
      indexName: indexName,
      searchClient,
      routing: true,
      searchFunction(helper) {
        const infiniteHits = document.getElementById('infiniteHits');
        const initialResults = document.getElementById('initialResults');
        if(helper.state.query !== '' && helper.state.query && infiniteHits && initialResults) {
          infiniteHits.style.display = 'block';
          initialResults.style.display = 'none';
        } else if (infiniteHits && initialResults) {
          infiniteHits.style.display = 'none';
          initialResults.style.display = 'block';
        }

        helper.search();
      }
    });
    searchIndex.start();
  }

  return {
    helper: algoliaHelper,
    searchIndex,
    searchClient,
    refine,
  };
}

export default algolia;



// WEBPACK FOOTER //
// ./algolia.js